import CloseNotification from './CloseNotification';

export default CloseNotification;
